export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7620.a64a65d2.jpg";